
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job/[slug]",
      function () {
        return require("private-next-pages/job/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job/[slug]"])
      });
    }
  